import { SportStructureOffer } from "@gp/offer";
import FavoriteStore from "@state/stores/offer/shared/FavoritesStore";
import RootStore from "@state/stores/RootStore";
import { LoaderStore } from "@state/stores/common";
import { HighlightsViewStore } from "@state/stores/offer/home/HighlightsViewStore";
import { LastMinuteViewStore } from "@state/stores/offer/home/LastMinuteViewStore";
import { LiveHighlightsViewStore } from "@state/stores/offer/home/LiveHighlightsViewStore";
import { MostPlayedViewStore } from "@state/stores/offer/home/MostPlayedViewStore";
export interface ISportSliderHeaderStore {
	type: StoreTypeEnum;
	isSelectedSportOutOfOffer: boolean;
	resetSelectedSportOutOfOffer: () => void;
	sportsList: {
		name: string;
		count: number;
		abrv: string;
		id: string;
		sortOrder: number;
	}[];
	selectedSportId: string;
	setSelectedSportId: (newSport: string) => void;
	eventsInSports: SportStructureOffer;
	route: string;
	isStoreInitialized: boolean;
	onInitialize: (params?: string) => void;
	onDispose: VoidFunction;
	shouldDisplayInitialLoader: boolean;
}

export type HomePageStoreConstructorsParameters = {
	rootStore: RootStore;
	favoritesStore: FavoriteStore;
	loaderStore: LoaderStore;
};

export enum StoreTypeEnum {
	HighlightsViewStore = "highlights",
	LastMinuteViewStore = "last-minute",
	LiveHighlightsViewStore = "top-live",
	MostPlayedViewStore = "most-played",
}

export interface StoreMap {
	highlights: HighlightsViewStore;
	"top-live": LiveHighlightsViewStore;
	"last-minute": LastMinuteViewStore;
	"most-played": MostPlayedViewStore;
}
